import React from 'react';
import PlatformTextarea from '@atlaskit/textarea';
import { adaptEventHandler } from '../../utils';
import { useCursorState } from '../../utils/useCursorState';
/**
 * A text area lets users enter long form text which spans over multiple lines.
 */
export var TextArea = function TextArea(props) {
  var _ref = props.forgeDoc.props,
    appearance = _ref.appearance,
    defaultValue = _ref.defaultValue,
    isCompact = _ref.isCompact,
    isMonospaced = _ref.isMonospaced,
    isReadOnly = _ref.isReadOnly,
    maxHeight = _ref.maxHeight,
    minimumRows = _ref.minimumRows,
    placeholder = _ref.placeholder,
    resize = _ref.resize,
    spellCheck = _ref.spellCheck,
    testId = _ref.testId,
    maxLength = _ref.maxLength,
    minLength = _ref.minLength,
    autoFocus = _ref.autoFocus,
    id = _ref.id,
    isRequired = _ref.isRequired,
    isDisabled = _ref.isDisabled,
    isInvalid = _ref.isInvalid,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    value = _ref.value,
    ariaInvalid = _ref['aria-invalid'],
    ariaLabelledby = _ref['aria-labelledby'],
    name = _ref.name;
  var _useCursorState = useCursorState(value, onChange),
    onChangeWithCursorState = _useCursorState.onChangeWithCursorState,
    inputRef = _useCursorState.inputRef;
  return /*#__PURE__*/React.createElement(PlatformTextarea
  // @ts-ignore type from ADS is missing the ref object. It is still supported
  , {
    ref: inputRef,
    appearance: appearance,
    defaultValue: defaultValue,
    isCompact: isCompact,
    isMonospaced: isMonospaced,
    isReadOnly: isReadOnly,
    maxHeight: maxHeight,
    minimumRows: minimumRows,
    placeholder: placeholder,
    resize: resize,
    spellCheck: spellCheck,
    testId: testId,
    maxLength: maxLength,
    minLength: minLength,
    autoFocus: autoFocus
    // Field props
    ,
    id: id,
    isRequired: isRequired,
    isDisabled: isDisabled,
    isInvalid: isInvalid,
    onChange: adaptEventHandler(onChangeWithCursorState),
    onBlur: adaptEventHandler(onBlur),
    onFocus: adaptEventHandler(onFocus),
    value: value,
    "aria-invalid": ariaInvalid,
    "aria-labelledby": ariaLabelledby,
    name: name
  });
};